<script>
    export default {
        props: {
            product: String
        },
        computed: {
            // ...mapGetters({
            //
            // }),
            username() {
                return 'John Doe';
                //return this.$store.getters.getAuthenticatedUser.name.split(' ').slice(0, -1).join(' ');
            }
        }
    }
</script>

<template>
    <div class="bg-image modal-content">
        <div class="modal-body-x text-left">
            <div class="steps text--left">
                <span>
                    <h4 class="" v-if="user">Hello {{ user.name.split(' ').slice(0, -1).join(' ') }}</h4>
                    <p>Glad to have you on-board, lets get you setup with {{product}}</p>
                </span>
            </div>
        </div>

        <img
            class="leaf l_right"
            src="/images/dashboard/shape_03.png"
            alt=""
        />

        <img
            class="middle_shape"
            src="/images/dashboard/shape_02.png"
            alt=""
        />

    </div>
</template>

<style scoped lang="scss">
    .modal-body-x {
        flex-wrap: wrap;
    }

    .modal-content {
        background-color: #0aa5e8;
        color: #fff;
        border: 1px solid #0aa5e8;
        border-radius: 0 !important;
        padding: 7% 3% 2% 3%;
    }

    .actions {
        margin-top: -25px;
    }

    .subscribe-action {
        width: 50%;
        margin: 20px auto;
    }

    .steps {
        margin-top: -15px;
        padding: 0 30px;

        h4 {
            flex-shrink: 0;
            font-family: "Google Sans",sans-serif;
            font-size: 28px;
            font-weight: 700;
            letter-spacing: 0;
            line-height: 44px;
            text-shadow: 0 1px 1px rgba(0,0,0,.12);
        }

        p {
            color: #fff;
        }
    }
    .footnotes {
        .small {
            color: white !important;
        }
    }
    .leaf {
        position: absolute;
        right: 0;
        bottom: 0px;
    }
    .middle_shape {
        position: absolute;
        left: 0;
    }
    .blue-border {
        border-color: #277bd9 !important;
        box-shadow: none;
    }

    .text-subscribe-btn {
        color: #EAC043 !important;
        position: relative;
        top: 4px;
    }

    .btn-space {
        padding: 20px;
        font-size: 18px;
        color: #EAC043;
    }
</style>
